import type { AdaptedNavGroup, AdaptedNavItem } from '@command-center/ui-system';
import { adminConfig } from './config';
import { resolveIcon } from './icons';

export type { AdaptedNavGroup, AdaptedNavItem };

/**
 * Extra paths a destination owns beyond its own route.
 *
 * People is one page serving two record types, so the sidebar row has to stay
 * lit on the Organizations tab as well as the Contacts one.
 */
const EXTRA_MATCHES: Record<string, string[]> = {
  people: ['/organizations'],
};

/**
 * One unlabelled group.
 *
 * The portal used to sort five nav items into four titled sections — Overview,
 * Feeds, Records, System — which added four lines of reading and no
 * information: with five destinations, the destination names are the
 * categories. The empty label tells the Sidebar to render no heading at all.
 */
export function getNavigationGroups(): AdaptedNavGroup[] {
  const items: AdaptedNavItem[] = adminConfig.navigation.map((item) => ({
    id: item.id,
    to: item.route,
    label: item.label,
    icon: resolveIcon(item.icon),
    moduleId: item.moduleId,
    matchPrefixes: EXTRA_MATCHES[item.id],
  }));

  return [{ label: '', items }];
}
